import { Box } from "@mui/material";
import FormType from "../../../../../../shared/components/FormType";
import { FieldConfigs } from "../../../../../../shared/components/FormType";
import { api } from "../../../../../../shared/hooks/api";

interface RequestImportProductFormProps {
    formData: any;
    onChange: (data: any) => void;
    isReserve?: boolean;
}

export const RequestImportProductForm = ({
    formData,
    onChange,
    isReserve = false,
}: RequestImportProductFormProps) => {
    const [{data: customers}] = api.get("/customers/", { page: 1, page_size: 1000 });

    const fields: FieldConfigs[] = [
        {
            label: "Người giao",
            type: "text",
            key: "receiver_name",
            required: false,
        },
        ...(!isReserve
            ? [
                  {
                      label: "Khách hàng",
                      type: "dropdown" as const,
                      key: "customer",
                      required: true,
                      options: customers?.results?.map((customer: any) => ({
                          text: customer.name,
                          value: customer.id,
                      })),
                      disabled: true,
                  },
              ]
            : []),
        {
            label: "Phương thức nhập",
            type: "dropdown",
            key: "import_method",
            required: true,
            options: [
                { text: "Nhập hàng sản xuất", value: "nhập hàng sản xuất" },
                { text: "Nhập hàng trả lại", value: "nhập hàng trả lại" },
                { text: "Khác", value: "khác" },
            ],
            disabled: true,
        },
        {
            label: "Ngày đề nghị",
            type: "calendar",
            key: "import_date",
            required: true,
        },
    ];

    return (
        <Box sx={{ width: "100%", height: "280px", overflowY: "auto" }}>
            <FormType
                title="Thông tin nhập kho"
                fields={fields}
                validated={false}
                requireData={formData}
                mergeFormData={onChange}
            />
        </Box>
    );
};
